<template>
  <div class="things">
    <div class="things-background">
      <div class="appHelmetysen">积分签到<img src="../../public/obraoag/appReturn.png" alt="" @click="appHelmetreturn()"></div>
      <div class="things-hior">
        <div class="things-hior-ince">
          <span>连续签到{{thecks.SIGN_IN_NUMBER_OF_DAYS}}天</span>
          <router-link :to="{path: 'inalch',query: {pembules: '8'}}"><span>签到规则</span></router-link>
        </div>
        <div class="things-hior-rant">
          <span>今日获得</span>
          <p>{{thecks.CURRENCY}}</p>
          <span>奖励积分</span>
        </div>
      </div>
      <el-calendar class="things-cale">
        <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
        <template slot="dateCell" slot-scope="{data}">
          <p>{{data.day.slice(-2)}}</p>
        </template>
      </el-calendar>
      <button class="things-tegn" :class="thecks.SIGN == '0' ? 'things-noal' : 'things-invd'" @click="thgrsn()" :disabled ="thecks.SIGN == '0' ? false : true">{{thecks.SIGN == '0' ? '立即签到' : '已签到'}}</button>
      <div class="things-chay">
        <div class="things-chay-title">您已连续签到{{thecks.SIGN_IN_NUMBER_OF_DAYS}}天</div>
        <div class="things-chay-bots">
          <div class="things-chay-bots-cent" v-for="erspay in 7" :key="erspay.index">
            <p v-if="erspay == '1'">+10</p>
            <p v-else-if="erspay == '2'">+20</p>
            <p v-else-if="erspay == '3'">+30</p>
            <p v-else-if="erspay == '4'">+50</p>
            <p v-else-if="erspay == '5'">+70</p>
            <p v-else-if="erspay == '6'">+80</p>
            <p v-else-if="erspay == '7'">+100</p>
            <img src="../../public/obraoag/sginrk.png" alt="" v-if="erspay <= thecks.SIGN_IN_NUMBER_OF_DAYS">
            <img src="../../public/obraoag/nosign.png" alt="" v-else>
            <p>第{{erspay}}天</p>
          </div>
          <div class="things-chay-grce"></div>
        </div>
      </div>
    </div>
    <!-- 微信WeUI样式 -->
    <div id="toast" :style="'display:' + thinAppden">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-icon-success-no-circle weui-icon_toast"></i>
        <p class="weui-toast__content">{{thinConnts}}</p>
      </div>
    </div>
  </div>
</template>


<script>
import "./obraojs/rem"
export default {
  data(){
    return{
      customerID: '',
      thecks: '',
      thinAppden: 'none',
      thinConnts: '',
      thcrde: ''
    }
  },
  created(){
    // 从缓冲中获取用户的token
    this.customerID = localStorage.getItem("usertoken");
    var thdata = new Date();
    var thYear = thdata.getFullYear();
    var thMoth = thdata.getMonth() + 1;
    this.thcrde = thYear + '-' + (thMoth < 10 ? '0' + thMoth : thMoth);
    // 获取app用户签到的天数
    this.$axios.post('app/client/signindays',this.$qs.stringify({
      MEMBER_ID: this.customerID
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.thecks = res.data;
      if(this.thecks.SIGN_IN_NUMBER_OF_DAYS != '0'){
        document.querySelector('.things-chay-grce').style.background = this.thecks.SIGN_IN_NUMBER_OF_DAYS < 3 ? 'linear-gradient(-90deg, #868686 ' + (100 - this.thecks.SIGN_IN_NUMBER_OF_DAYS * 50) + '%, #ECECEC 100%)' : 'linear-gradient(-90deg, #868686 0%, #ECECEC ' + (100 - (this.thecks.SIGN_IN_NUMBER_OF_DAYS - 2)) * 25 + '%)';
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
    // 获取app用户签到时间的展示
    this.$axios.post('app/client/appSignData',this.$qs.stringify({
      MEMBER_ID: this.customerID,
      CREATE_DATE: this.thcrde
    }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
    .then(res => {
      this.$('.el-calendar__button-group').remove('');
      for(var i in res.data){
        this.$('.current').eq(res.data[i].CREATE_DATE.slice(8,10) - 1).find("div").addClass('things-cale-over');
      }
    })
    .catch(() => {
      console.log('获取失败');
    });
  },
  mounted(){
    
  },
  methods:{
    // 展示已经签到的日期
    // thsned(){
    //   this.$('.el-calendar__button-group').remove('');
    //   for(var i in this.aa){
    //     this.$('.current').eq(this.aa[i] - 1).find("div").addClass('things-cale-over');
    //   }
    // },
    // 点击立即签到触发
    thgrsn(){
      // 点击进行签到
      this.$axios.post('app/client/signIn',this.$qs.stringify({
        MEMBER_ID: this.customerID
      }),{headers:{'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        if(res.data.result == 'success'){
          this.thinConnts = '签到成功';
          this.thinAppden = 'block';
          let that = this;
          setTimeout(function(){
            that.thinAppden = 'none';
            location.reload();
          },1400)
        }else{
          this.thinConnts = '签到失败';
          this.thinAppden = 'block';
          let that = this;
          setTimeout(function(){
            that.thinAppden = 'none';
          },1400)
        }
      })
      .catch(() => {
        console.log('获取失败');
      });
    },
    // 点击返回上一层
    appHelmetreturn(){
      this.$router.go(-1);
    }
  }
}
</script>
<style scoped>
  @import "obraocs/things.css";
</style>